import React, { useEffect } from 'react';

import staticTemplateStyles from '@/finsight/ui/components/staticPages/StaticTemplate/staticTemplate.module.scss';
import styles from './styles.module.scss';

const Privacy = () => {
  useEffect(() => {
    const id = window.location?.hash.replace('#', '');
    setTimeout(() => {
      document.getElementById(id)
        ?.scrollIntoView();
    }, 0);
  }, []);
  return (
    <>
      <p>
        Finsight Group, Inc (“Finsight”, “We”, “Our”) is committed to safeguarding your
        privacy online. This Privacy Policy governs the manner in which we collect, use,
        maintain and disclose information collected from our users and the rights users have
        to their personal information. This privacy policy applies to all products and services offered by Finsight
        including Allocate, CapEdge.com, CreditFlowResearch.com, DealRoadshow.com, DealVDR.com, Evercall.co,
        InvestorSet.com, LoanSend.com, QuantumCF.com, ResearchRoom.com, SwiftBridge.com, VeriSend.com and 17g5.com (the
        “Sites”). SwiftBridge.com is operated by SwiftBridge LLC and QuantumCF.com is operated by QuantumCF Inc., each a
        wholly-owned affiliate of Finsight Group, Inc. References in this Privacy Policy to “Finsight,” “We” and “Our”
        include SwiftBridge LLC, QuantumCF Inc. and Finsight's other affiliates that provide the Sites.
      </p>
      <h3>Personal Identification Information</h3>
      <p>
        To perform our services, Finsight may collect personal identification information (“Personal Data”) from
        users in a variety of ways, including, but not limited to, when users visit our Sites, register on our
        Sites, view a page or transaction, download documents related to a page or transaction, subscribe to a
        newsletter, respond to a survey, fill out a form, and in connection with other activities, services,
        features or resources we make available on our Sites. We may collect a user’s IP Address and users may be
        asked for, among other things, name, company, email address, and phone number.
      </p>
      <h3>Non-personal Identification Information</h3>
      <p>
        To ensure the quality and reliability of our services, we may collect non-personal identification
        information
        about users whenever they interact with our Sites. Non-personal identification information may include the
        browser name, the type of computer and technical information about users' means of connection to our Sites,
        such as the operating system and the Internet Service Providers utilized and other similar information.
      </p>
      <h3>Third-Party Processors</h3>
      <p>
        Finsight may share information, including Personal Data, with its third-party service providers used to
        provide hosting, backup, storage, communications technology, and other services for Finsight. These
        third-party
        service providers may have access to or process Personal Data for the purpose of providing these services for
        Finsight;
        however, we do not permit our third-party service providers to use any Personal Data that we share with them
        for any
        other purpose than as necessary to provide services to Finsight.
      </p>
      <h4>Material Vendors</h4>
      <table>
        <thead>
          <tr>
            <th>Third-Party Service Provider</th>
            <th>Purpose</th>
            <th>In-Scope Services</th>
            <th>Entity Country</th>
            <th>Website</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Amazon AWS</td>
            <td>Hosting</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://aws.amazon.com/</td>
          </tr>
          <tr>
            <td>Google Workspace</td>
            <td>Email Service Provider and Enterprise Management</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://workspace.google.com/</td>
          </tr>
          <tr>
            <td>Front</td>
            <td>Email Management</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://front.com/</td>
          </tr>
          <tr>
            <td>Bird</td>
            <td>Email Service Provider</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://bird.com/products/email</td>
          </tr>
          <tr>
            <td>Twilio</td>
            <td>Communications Technology</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://www.twilio.com/</td>
          </tr>
          <tr>
            <td>Notion</td>
            <td>Internal Knowledge Base</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://www.notion.com/</td>
          </tr>
          <tr>
            <td>Salesforce | Slack</td>
            <td>CRM and Communications Technology</td>
            <td>All Finsight Services</td>
            <td>United States</td>
            <td>https://www.salesforce.com/</td>
          </tr>
        </tbody>
      </table>
      <h4>Non-Material Vendors</h4>
      <table>
        <thead>
          <tr>
            <th>Third-Party Service Provider</th>
            <th>Purpose</th>
            <th>In-Scope Services</th>
            <th>Entity Country</th>
            <th>Website</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Microsoft Teams</td>
            <td>Webinar and Meeting Provider</td>
            <td>Evercall, Operations</td>
            <td>United States</td>
            <td>https://www.microsoft.com/en-us</td>
          </tr>
          <tr>
            <td>Zoom</td>
            <td>Webinar and Meeting Provider</td>
            <td>Evercall, Operations</td>
            <td>United States</td>
            <td>https://zoom.us/</td>
          </tr>
          <tr>
            <td>Webex</td>
            <td>Webinar and Meeting Provider</td>
            <td>Evercall, Operations</td>
            <td>United States</td>
            <td>https://www.webex.com/</td>
          </tr>
          <tr>
            <td>SwiftBridge</td>
            <td>Conferencing Provider</td>
            <td>Evercall</td>
            <td>United States</td>
            <td>https://swiftbridge.com/</td>
          </tr>
          <tr>
            <td>Okta</td>
            <td>Internal IAM Technology</td>
            <td>Operations</td>
            <td>United States</td>
            <td>https://www.okta.com/</td>
          </tr>
          <tr>
            <td>Clari</td>
            <td>CRM Technology</td>
            <td>Operations</td>
            <td>United States</td>
            <td>https://www.clari.com/</td>
          </tr>
          <tr>
            <td>Descript</td>
            <td>Audio Editing</td>
            <td>Deal Roadshow</td>
            <td>United States</td>
            <td>https://www.descript.com/</td>
          </tr>
          <tr>
            <td>Anthropic</td>
            <td>Internal Workflows and Processes</td>
            <td>Operations</td>
            <td>United States</td>
            <td>https://www.anthropic.com/</td>
          </tr>
        </tbody>
      </table>
      <h3 className={ styles.policiesBlock }>
        Web Browser Cookies
        <span
          className={ styles.policiesAnchor }
          id="cookiesPolicy"
        />
      </h3>
      <p>
        Our Sites may use "cookies" to enhance the user experience. A cookie is a small data file transferred to your
        computer. Some cookies are "session cookies," which are deleted when you close your browser, while others are
        "persistent cookies" that remain stored on your computer after you leave the Sites and close your browser
        window. Our Sites use both session and persistent cookies. You have the ability to delete cookies from your
        hard drive at any time or configure your Internet browser to reject or notify you when a cookie is being
        placed
        on your hard drive. However, please note that blocking cookies may prevent you from using certain features on
        our Sites, and you may be required to re-enter information more frequently to access certain services on the
        Sites. For more information about cookies, including how to control and delete them,
        please visit http://www.allaboutcookies.org/.
      </p>
      <p>
        Below is a summary of the types of cookies we use and why we use them.
      </p>
      <p>
        1. Functionality Cookies: These cookies are essential for enabling you to browse our Sites and use their
        features. Without these cookies, basic Site services cannot be provided, or the functionality will be
        significantly impaired. These cookies collect anonymous information about how visitors use our Sites and
        whether they encounter error messages. The information gathered is aggregated and anonymized. We use these
        cookies to improve the functionality and performance of the Sites and to analyze trends on an anonymized
        basis.
        The information associated with these cookies will not personally identify you. By choosing these preferences,
        you agree that we can place these functional cookies on your device. We have a legitimate business interest
        in placing these cookies on your device.
      </p>
      <p>
        2. Marketing Cookies: These cookies are used to deliver marketing communications that are relevant to your use
        and future use of Finsight applications. Marketing cookies help us tailor our advertising campaigns and
        measure
        their effectiveness. These cookies are not directly identifying but are provided on an opt-in basis to comply
        with relevant regulations and data protection laws.
      </p>
      <p>
        We strive to ensure that all cookies used on our Sites are lawful and comply with applicable data protection
        laws. By continuing to use our Sites, you consent to the placement of cookies on your device for the purposes
        outlined above.
      </p>
      <h3>Your Personal Information</h3>
      <p>
        By providing Personal Data to us, you consent to us collecting, holding, using and disclosing your Personal
        Data
        in accordance with this Privacy Policy. If you are under 18 years of age, you must have, and warrant to the
        extent
        permitted by law to us, that you have your parent or legal guardian’s permission to access and use the Sites
        and
        they (your parents or guardian) have consented to you providing us with your Personal Data. You do not have to
        provide
        Personal Data to us, however, if you do not, it may affect your use of our Sites.
      </p>
      <p>
        Finsight’s services are utilized by various organizations to facilitate the secure transfer of documents and
        information to identifiable, qualified and / or authorized recipients. Toward this end, we may process and
        share personal identification information and usage statistics with our clients (underwriters, issuers,
        sponsors and their affiliates and advisors) for certain legitimate business purposes. This includes, but
        is not limited to, when users visit our Sites, view a profile, view a presentation, click on external
        links, securely download documents related to a profile or transaction, and the ability to identify and
        prevent fraud. We may use third party service providers to help us operate our Sites or administer
        activities
        on our behalf. We may share your information with these third parties for those limited purposes.
      </p>
      <p>
        In addition, we may collect, hold, use and disclose your Personal Data for the following purposes:
      </p>
      <ul className={ staticTemplateStyles.bulletList }>
        <li>
          to enable you to customize or personalize your experience of our Sites
        </li>
        <li>
          to enable you to access and use our Sites, associated applications and associated social media platforms
        </li>
        <li>
          to contact and communicate with you
        </li>
        <li>
          for internal record keeping and administrative purposes
        </li>
        <li>
          to comply with our legal obligations and resolve any disputes that we may have
        </li>
      </ul>
      <p>
        If we receive Personal Data about you from a third party, we will protect it as set out in this Privacy
        Policy.
        If you are a third party providing Personal Data about somebody else, you represent and warrant that you have
        such person’s consent to provide the Personal Data to us.
      </p>
      <p>
        Whenever we process data for these purposes we will ensure that we always keep your Personal Data rights
        in high regard and take account of these rights. You have the right to object to this processing by
        emailing <a href="mailto:privacy@finsight.com">privacy@finsight.com</a>. Doing so may prevent your
        ability to access our Sites.
      </p>
      <h3>How We Protect Your Information</h3>
      <p>
        We adopt appropriate data collection, storage and processing practices and security measures to
        protect against unauthorized access, alteration, disclosure or destruction of your personal
        information, username, password, transaction information and data stored on our Sites.
      </p>
      <p>
        Sensitive and private data exchange between our Sites and its users happens over an SSL secured
        communication channel and is end-to-end encrypted and protected with digital signatures.
      </p>
      <p>
        For more information on our security, please see: https://finsight.com/security-policy
      </p>
      <h3>Third Party Websites</h3>
      <p>
        Users may find content on our Sites that links to the sites and services of our partners, suppliers,
        advertisers, sponsors, licensors and other third parties. We do not control the content or links
        that appear on these sites and are not responsible for the practices employed by websites linked to
        or from our Sites. In addition, these sites or services, including their content and links, may be
        constantly changing. These sites and services may have their own privacy policies and customer
        service policies. Browsing and interaction on any other website, including websites which have a
        link to, or from, our Sites, is subject to that website's own terms and policies.
      </p>
      <p>
        No mobile information will be shared with third parties/affiliates for marketing/promotional purposes.
        All other categories exclude text messaging originator opt-in data and consent; this information will
        not be shared with any third parties.
      </p>
      <h3>Changes To This Privacy Policy</h3>
      <p>
        Finsight has the discretion to update this Privacy Policy at any time and without prior notice to reflect
        changes in our information practices and/or relevant laws. Upon substantive changes we will post notice on
        Sites to notify and require opt in to these changes. We encourage users to frequently check this page for
        any non-substantive changes to stay informed about how we are helping to protect the personal information
        we collect. You acknowledge and agree that it is your responsibility to review this Privacy Policy
        periodically and become aware of these modifications. We will indicate at the bottom of this Privacy
        Policy when it was last updated.
      </p>
      <h3>Your Acceptance Of These Terms</h3>
      <p>
        By using our Sites, you signify your acceptance of this policy and terms of service. If you do not
        agree to this policy, please do not use our Sites. Your continued use of our Sites following the
        posting of changes to this policy will be deemed your acceptance of those changes.
      </p>
      <h3>Limits Of Our Policy</h3>
      <p>
        Our Sites may link to external sites that are not operated by us. Please be aware that we have no control
        over the content and policies of those sites, and cannot accept responsibility or liability for their
        respective privacy practices.
      </p>
      <h3>Contacting Us</h3>
      <p>
        If you have any questions about this Privacy Policy, the practices of our Sites, or your dealings
        with our Sites, please contact us at <a href="mailto:privacy@finsight.com">privacy@finsight.com</a>.
      </p>
      <h3>Commitment To Comply With The EU-U.S. DPF And The UK Extension To The EU-U.S. DPF, And The Swiss-U.S.
        DPF
      </h3>
      <p>
        This section covers Finsight’s collection, use and retention of Personal Data provided by those who
        access and use (individually, a “user” and collectively, “users”) our Sites, and those whose Personal
        Data Finsight transfers from European Union member countries, the United Kingdom,
        and Switzerland to the United States.
        Finsight is committed to the EU-U.S. Data Privacy Framework (EU-U.S. DPF), the UK Extension to the EU-U.S. DPF,
        and the Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) and to the rights of EU, UK, and Swiss individuals.
      </p>
      <h3>Privacy Practices (EU-U.S. DPF And The UK Extension To The EU-U.S. DPF, And The Swiss-U.S. DPF)</h3>
      <p>
        Finsight Group, Inc. and its U.S. subsidiaries (including SwiftBridge LLC and QuantumCF Inc.) comply with the
        EU-U.S. Data Privacy Framework (EU-U.S. DPF), the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. Data
        Privacy Framework (Swiss-U.S. DPF) as set forth by the U.S. Department of Commerce. Finsight Group, Inc. has
        certified to the U.S. Department of Commerce that it and its U.S. subsidiaries - SwiftBridge LLC and QuantumCF
        Inc. - adhere to the EU-U.S. Data Privacy Framework Principles (EU-U.S. DPF Principles) with regard to the
        processing of Personal Data received from the European Union and the United Kingdom in reliance on the EU-U.S.
        DPF and the UK Extension to the EU-U.S. DPF. Finsight Group, Inc. has certified to the U.S. Department of
        Commerce that it and its U.S. subsidiaries - SwiftBridge LLC and QuantumCF Inc. - adhere to the Swiss-U.S. Data
        Privacy Framework Principles (Swiss-U.S. DPF Principles) with regard to the processing of Personal Data
        received from Switzerland in reliance on the Swiss-U.S. DPF.
        If there is any conflict between the terms in this privacy policy and the EU-U.S. DPF Principles and/or
        the Swiss-U.S. DPF Principles, the Principles shall govern. To learn more about the Data Privacy Framework
        (DPF) program, and to view our certification, please visit&nbsp;
        <a
          href="https://www.dataprivacyframework.gov/"
          target="_blank"
        >
          https://www.dataprivacyframework.gov/
        </a>.
      </p>
      <h3>Inquiries And Complaints (EU-U.S. DPF And The UK Extension To The EU-U.S. DPF, And The Swiss-U.S. DPF)</h3>
      <p>
        In compliance with the EU-U.S. DPF, the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. DPF, Finsight
        commits to resolve DPF Principles-related complaints about our collection and use of your personal
        information. EU, UK, and Swiss individuals with inquiries or complaints regarding our handling of personal
        data received in reliance on the EU-U.S. DPF, the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. DPF
        should first contact Finsight at privacy@finsight.com. Finsight will respond within 45 days.
      </p>
      <p>
        In compliance with the EU-U.S. DPF, the UK Extension to the EU-U.S. DPF, and the Swiss-U.S. DPF, Finsight
        commits to cooperate and comply respectively with the advice of the panel established by the EU data
        protection authorities (DPAs), the UK Information Commissioner’s Office (ICO), and the Swiss Federal
        Data Protection and Information Commissioner (FDPIC) with regard to unresolved complaints concerning our
        handling of personal data received in reliance on the EU-U.S. DPF, the UK Extension to the EU-U.S. DPF,
        and the Swiss-U.S. DPF.
      </p>
      <p>
        If neither Finsight nor the relevant supervisory authority resolves your complaint, you may have the possibility
        to engage in binding arbitration through the Data Privacy Framework Panel. For more information on this
        option, please see Annex I of the EU-U.S. Data Privacy Framework Principles.
      </p>
      <h3>Limitations On Use And Disclosure Of Personal Data (EU-U.S. DPF And The UK Extension To The EU-U.S. DPF, And
        The Swiss-U.S. DPF)
      </h3>
      <p>
        Finsight may use the Personal Data it receives from the EEA, the United Kingdom,
        and Switzerland for the purposes set forth in
        this Privacy Policy or as you may otherwise be notified. We take reasonable steps to ensure that the
        Personal Data we process is reliable for its intended use, accurate, complete, and current to the extent
        necessary for the purposes for which we use the Personal Data. We will adhere to the Principles for as long
        as we retain the Personal Data collected under the Data Privacy Framework.
      </p>
      <p>
        Finsight limits access to Personal Data to those persons in Finsight’s organization, or agents of
        Finsight, that have a specific business purpose for maintaining and processing such Personal Data.
        Individuals who have been granted access to Personal Data are aware of their responsibilities to protect
        the security, confidentiality and integrity of that information and have been provided training and
        instruction on how to do so. Finsight takes appropriate measures to protect the security of Personal Data
        in order to ensure it is only accessed for its intended use. Personal data is protected from loss,
        misuse, unauthorized access, disclosure, alteration and destructions, taking into account the risks
        involved in the processing and the nature of the Personal Data.
      </p>
      <p>
        As a user of the Sites, you agree to only process the Personal Data as necessary
        to review and evaluate the information included on the Sites and to protect
        the Personal Data with at least the same level of protection as provided in
        the Data Privacy Framework. You will notify Finsight if you make a determination
        that you cannot meet this obligation, and to cease processing or take other reasonable
        and appropriate steps to remediate when such determination is made.
      </p>
      <h3>Access To Your Personal Data, Limitations Of Use And Disclosure</h3>
      <p>
        All users have the right to access, request corrections, and delete
        (subject to legal and regulatory compliance) their Personal Data.
        You may do so by writing to Finsight via the Contacting Us section of this Privacy Policy.
      </p>
      <p>
        Finsight may perform services on behalf of its clients. All users have the right to opt-out or discontinue
        using the Finsight services and discontinue receiving email communications from Finsight at any time.
        Due to the predominant use case of our services as a secure medium to transfer information and documents
        to identifiable, qualified and / or authorized recipients, Finsight may not be able to offer its full
        services to users who do not wish to disclose their Personal Data.
      </p>
      <p>
        Finsight has strict policies in place to protect the security and confidentiality of all user Personal Data
        we receive. Finsight limits disclosure of Personal Data to employees, its clients, its Sites users,
        and other EU-U.S. Data Privacy Framework (EU-U.S. DPF) and the UK Extension to the EU-U.S. DPF, and
        the Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) participants that have a specific business purpose for
        collecting, maintaining and processing such Personal Data.
      </p>
      <p>
        Finsight may retain Personal Data for a minimum of 6-years to satisfy regulatory compliance, including,
        but not limited to, the Financial Industry Regulatory Authority (FINRA). For more information on FINRA,
        please visit <a href="http://www.finra.org/" target="_blank">http://www.finra.org/</a>
      </p>
      <p>
        Finsight may disclose Personal Data as required by law, regulation or the rules of practice of a governmental
        or quasi-governmental body. Finsight may also disclose Personal Data to law enforcement officials in response
        to a lawful request made pursuant to national security interests or law enforcement requirements.
        Though we do not currently anticipate a change in our ownership, in the event of a sale of the company or
        a significant portion of its assets, Finsight may disclose or transfer Personal Data to a purchasing party
        that is EU-U.S. Data Privacy Framework (EU-U.S. DPF) and the UK Extension to the EU-U.S. DPF, and
        the Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) compliant, or has implemented another valid
        data transfer mechanism, such as EU Standard Contractual Clauses, as applicable.
      </p>
      <p>
        If Personal Data covered by this Privacy Policy is to be used for a new purpose that is materially different
        from that for which the Personal Data was originally collected or subsequently authorized, or is to be
        disclosed to a non-agent third party in a manner not specified in this Policy, Finsight will provide you
        with an opportunity to choose whether to have your Personal Data so used or disclosed. Requests to opt
        out of such uses or disclosures of Personal Data should be sent to us as specified in the "Contact
        Information" section below.
      </p>
      <p>
        Finsight is subject to the investigatory and enforcement powers of the U.S. Federal Trade Commission (FTC).
      </p>
      <h3>
        Accountability for Onward Transfer (EU-U.S. DPF And The UK Extension To The EU-U.S. DPF, And The Swiss-U.S. DPF)
      </h3>
      <p>
        If you are an EU, UK, or Swiss Individual, where we transfer your Personal Data to third party service
        providers (see above) who perform services for us or on our behalf, we are responsible for the processing
        of that data by them and shall remain liable if they process your Personal Data in a manner inconsistent
        with DPF Principles referred to above, unless we prove that we are not responsible for the event giving
        rise to the damage.
      </p>
      <h3>California Privacy Rights</h3>
      <p>
        In accordance with the California Consumer Privacy Act of 2018 (“CCPA”), as amended by the California Privacy
        Rights Act of 2020 (“CPRA”), California residents are entitled to certain additional disclosures and rights
        regarding their Personal Data.
      </p>
      <h4>Personal Data Collected</h4>
      <p>
        In the past 12 months, Finsight has collected the categories of Personal Data described in the “Personal
        Identification Information” section of this Privacy Policy. These categories include identifiers such as name,
        company, email address, phone number, and IP address. Finsight collects this information directly from users
        when they interact with our Sites (for example, by registering, filling out forms, or downloading documents),
        and through other user interactions with our services (for example, when existing users invite users to our
        platform).
      </p>
      <h4>Use and Disclosure of Personal Data</h4>
      <p>
        The Personal Data collected by Finsight is used solely to provide and support our services, as further
        described in the “Your Personal Information” section of this Privacy Policy. The categories of third parties to
        whom we may disclose Personal Data are described in the “Access To Your Personal Data, Limitations Of Use And
        Disclosure” section of this Privacy Policy.
      </p>
      <p>
        Finsight does not sell Personal Data. We also do not “share” Personal Data as that term is defined under the
        CCPA/CPRA (i.e., for cross-context behavioral advertising). Additional details can be found within the “Your
        Personal Information” section of this Privacy Policy.
      </p>
      <h4>Rights of California Residents</h4>
      <p>
        California residents have the following rights under the CCPA/CPRA, subject to applicable legal and regulatory
        requirements, as further described in the section titled “Access To Your Personal Data, Limitations Of Use And
        Disclosure” of this Privacy Policy:
      </p>
      <ul className={ staticTemplateStyles.bulletList }>
        <li>Right to Know what Personal Data we collect, use, and disclose</li>
        <li>Right to Delete Personal Data, subject to applicable legal and regulatory requirements</li>
        <li>Right to Correct Personal Data</li>
        <li>Right to Opt-Out of Sale or Sharing of Personal Data</li>
        <li>Right to Limit the Use of Sensitive Personal Information</li>
        <li>Right to Non-Discrimination for exercising these rights</li>
      </ul>
      <h4>How to Exercise Your Rights</h4>
      <p>
        Requests to exercise these rights may be done by writing to Finsight via the “Contacting Us” section of this
        Privacy Policy.
      </p>
      <h3>Contact Information</h3>
      <span>Finsight Group, Inc.</span>
      <br />
      <span>530 7th Ave, 27th Fl</span>
      <br />
      <span>New York, NY 10018</span>
      <br />
      <a href="mailto:privacy@finsight.com">privacy@finsight.com</a>
      <p>Last Updated: September 10, 2026</p>
    </>
  );
};

export default Privacy;
